import PropTypes from 'prop-types';
import FacetCheckboxes from '../attributes/checkboxes/facet_checkboxes';

const FacetStandards = ({ context, facets, showMore }) => {
  const ccssAffiliation = () => {
    if (!(showMore && facets.ccss_affiliation)) return null;

    return (
      <div>
        <FacetCheckboxes
          context={context}
          items={facets.ccss_affiliation}
          showMore={showMore}
        ></FacetCheckboxes>
      </div>
    );
  };

  return (
    <div className="show-only-standards-resources">
      <FacetCheckboxes context={context} items={facets.ccss} showMore={showMore} />
      {ccssAffiliation()}
    </div>
  );
};

FacetStandards.propTypes = {
  showMore: PropTypes.bool,
  facets: PropTypes.object,
  context: PropTypes.object
};

export default FacetStandards;
